import './VisuallyHidden.scss'
import type { ComponentProps } from 'react'
import { clx } from '../clx'

/** Present to assistive technology, invisible on screen. */
export function VisuallyHidden({ className, ...rest }: ComponentProps<'span'>) {
  return <span {...rest} className={clx('visually-hidden', className)} />
}
